import { render, staticRenderFns } from "./Carbon.vue?vue&type=template&id=051c42ad&"
import script from "./Carbon.vue?vue&type=script&lang=ts&"
export * from "./Carbon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports